import DBEngine from '@/database/_Base';
import Helper from '@/resources/Helper';

const pipelineTable = 'syncPipeline';

const functions = {
	async getDataVersion(tableName) {
		const db = await DBEngine.getDb();

		return new Promise(resolve => {
            const trans = db.transaction([tableName], 'readonly');
            const store = trans.objectStore(tableName);
            
            trans.oncomplete = () => {
				resolve(result);
			};

            let result = 0;

            store.openCursor().onsuccess = (e) => {
				const cursor = e.target.result;

                if (cursor) {
                    result = cursor.key;
                }
			};
		});
	},
	async syncMasterVersion(tableName) {
		const currentVersion = await this.getDataVersion(tableName);
		// const path = '/api/sync-data/sync-master-data';
		const param = {
			tableName: tableName,
			clientVersion: currentVersion
		};

		console.log('Sync Data "' + tableName + '" with param ', param);
		
		// const response = await Helper.postAPI(Helper.getApiUrl(), path, param, Helper.getHeaderToken());

		// await this.checkAndSyncDataVersion(tableName, response);
	},
	async syncStoreVersion(tableName) {
		const currentVersion = await this.getDataVersion(tableName);
		// const path = '/api/sync-data/sync-store-data';
		const param = {
			tableName: tableName,
			clientVersion: currentVersion
		};

		console.log('Sync Data "' + tableName + '" with param ', param);
		
		// const response = await Helper.postAPI(Helper.getApiUrl(), path, param, Helper.getHeaderToken());

		// await this.checkAndSyncDataVersion(tableName, response);
	},
	async syncDataVersion(tableName) {
		const currentVersion = await this.getDataVersion(tableName);
		// const path = '/api/sync-data/sync-client-data';
		const param = {
			tableName: tableName,
			clientVersion: currentVersion
		};

		console.log('Sync Data "' + tableName + '" with param ', param);
		
		// const response = await Helper.postAPI(Helper.getApiUrl(), path, param, Helper.getHeaderToken());

		// await this.checkAndSyncDataVersion(tableName, response);
	},
	async checkAndSyncDataVersion(tableName, response) {
		if (response.data) {
			if (response.data.isRequireUpdate) {
				await this.clearData(tableName);
				await this.addNewVersionData(tableName, response.data.result);
			}
		}
	},
	async addNewVersionData(tableName, content) {
		const db = await DBEngine.getDb();

		return new Promise(resolve => {
			const trans = db.transaction([tableName], 'readwrite');
            const store = trans.objectStore(tableName);
            
			trans.oncomplete = () => {
				resolve();
			};

			store.put(content.data, content.version);
		});
    },
	async clearData(tableName) {
		const db = await DBEngine.getDb();

		return new Promise(resolve => {
			const trans = db.transaction([tableName], 'readwrite');
            const store = trans.objectStore(tableName);
            
			trans.oncomplete = () => {
				resolve();
			};

            store.clear();
		});
    },
	async setupSyncPipeline(tableName, operation, data) {
		await this.saveSyncData(tableName, operation, data);
		this.sendSyncData();
	},
	async saveSyncData(tableName, operation, data) {
		const timestamp = Helper.getClientTime();
		const db = await DBEngine.getDb();
		const content = {
			tableName: tableName,
			operation: operation,
			data: data
		};

		return new Promise(resolve => {
			const trans = db.transaction([pipelineTable], 'readwrite');
            const store = trans.objectStore(pipelineTable);
            
			trans.oncomplete = () => {
				resolve();
			};

			store.put(content, timestamp);
		});
	},
	async sendSyncData() {
		const syncList = await this.getSyncPipelineData();

		if (syncList && syncList.length > 0) {
			const time = Helper.getClientTime();
			const path = '/api/sync-data/submit-client-data';
			const param = {
				data: syncList,
				time: time
			};
	
			const result = await Helper.postAPI(Helper.getApiUrl(), path, param, Helper.getHeaderToken());
			
			if (result.data.success) {
				this.clearData(pipelineTable);
			}
		}
	},
	async getSyncPipelineData() {
		const db = await DBEngine.getDb();

		return new Promise(resolve => {
            const trans = db.transaction([pipelineTable], 'readonly');
            const store = trans.objectStore(pipelineTable);
            
            trans.oncomplete = () => {
				resolve(result);
			};

            let result = [];

            store.openCursor().onsuccess = (e) => {
				const cursor = e.target.result;

                if (cursor) {
                    result.push(cursor.value);
					cursor.continue();
                }
			};
		});
	}
}

export default functions;